import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";

export enum ApplyScope {
  Instance = "instance",
  Recurring = "recurring",
}

interface Props {
  open: boolean;
  onCancel: () => void;
  onChoose: (scope: ApplyScope) => void;
}

export const ApplyScopeDialog: React.FC<Props> = ({
  open,
  onCancel,
  onChoose,
}) => {
  return (
    <Dialog maxWidth="xs" fullWidth open={open} onClose={onCancel}>
      <DialogTitle>Apply changes to</DialogTitle>
      <DialogContent>
        <Stack gap={1.5}>
          <Typography variant="body2">
            This is part of a recurring series. Where should the changes apply?
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Per-day host overrides on the series are preserved when applying to
            all events; only the default host is updated.
          </Typography>
          <Typography variant="caption" color="text.secondary">
            A Partner-only (private) change applied to all events also reaches
            events that were edited individually.
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary">
          Cancel
        </Button>
        <Button onClick={() => onChoose(ApplyScope.Instance)} color="primary">
          Only this event
        </Button>
        <Button
          onClick={() => onChoose(ApplyScope.Recurring)}
          color="primary"
          variant="contained"
        >
          All events
        </Button>
      </DialogActions>
    </Dialog>
  );
};
